enum BenchmarkingDashboardDetailsReportTypeEnum {
  WithAddresses = "Access Points (With Addresses)",
  WithoutAddresses = "NPI (Without Addresses)",
}

export { BenchmarkingDashboardDetailsReportTypeEnum };
